module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_25.45ac1602.png";